export default __webpack_public_path__ + "static/media/slide-3.5e9a0138.jpg";